// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"160":"9a8eed01","351":"bb3146a6","399":"ba9c014a","936":"6bdf2522","946":"696e758e","980":"b7ce923a"}[chunkId] + ".js";
};